import { textos } from '../../textos';

export function AvisoSoloEscritorio(): React.JSX.Element {
  return (
    <section className="flex flex-col gap-3 p-4">
      <h1 className="text-xl font-semibold text-brand-text">{textos.soloEscritorio.titulo}</h1>
      <p className="text-brand-text-muted">{textos.soloEscritorio.ayuda}</p>
    </section>
  );
}
